module.exports = __webpack_public_path__ + "static/media/bg-big.992ceb7a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/Footer/bg-big.svg
// module id = 252
// module chunks = 0